(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/forgot-password-reset/:forgotToken', {
      templateUrl: 'modules/outside/forgot-password/forgot-password-reset.html',
      controller: 'ForgotPasswordResetCtrl'
    });
    $routeProvider.when('/forgot-password', {
      templateUrl: 'modules/outside/forgot-password/forgot-password.html',
      controller: 'ForgotPasswordCtrl'
    });
  }]).controller('ForgotPasswordCtrl', ['$scope', '$http', 'Config', 'Validation', 'Utils', function ForgotPasswordCtrl($scope, $http, Config, Validation, Utils) {
    $scope.submitted = false;
    $scope.resetPassword = function resetPassword() {
      $scope.emailFound = null;
      $scope.formError = null;
      if (Validation.isBlank($scope.username)) {
        $scope.formError = "User name or e-mail is required.";
        return;
      }
      var user = {
        email: $scope.username,
        url: Utils.qualifyURL("outside.html#/forgot-password-reset/")
      };
      $http.post(Config.get().apiUrl + '/users/forgot-password', user).then(function success() {
        $scope.emailFound = true;
      }, function error() {
        //try to resend any invitation emails
        $http.post(Config.get().apiUrl + '/invitations/resend', {
          email: $scope.username
        }).then(function () {
          $scope.emailFound = true;
          $scope.invitation = true;
        }, function error(response) {
          if (response.status === 404) {
            $scope.emailFound = false;
          }
        });
      });
      $scope.submitted = true;
    };
  }]).controller('ForgotPasswordResetCtrl', ['$scope', '$routeParams', '$http', 'Config', 'Validation', 'Utils', 'Logger', function ForgotPasswordResetCtrl($scope, $routeParams, $http, Config, Validation, Utils, Logger) {
    $scope.passwordResetData = {};
    $scope.formErrors = null;
    $scope.saving = false;
    var forgotTokens = Base64.decode(decodeURIComponent($routeParams.forgotToken)).split(":"),
      email = forgotTokens[0],
      token = forgotTokens[1],
      xsrfToken = forgotTokens[2],
      id = forgotTokens[3],
      authString = "Bearer " + token,
      params = {
        headers: {
          "Authorization": authString,
          "X-Requested-By": xsrfToken
        }
      };
    $scope.passwordResetData.email = email;
    function validateForm($scope) {
      return Validation.validate({
        "password": {
          "rules": {
            "required": true,
            "password": true
          },
          "display": "New password",
          "value": $scope.passwordResetData.password
        },
        "passwordConfirm": {
          "rules": {
            "required": true,
            "matches": "password"
          },
          "display": "Confirm new password",
          "value": $scope.passwordResetData.passwordConfirm
        }
      });
    }
    $scope.resetPassword = function resetPassword() {
      $scope.formErrors = validateForm($scope);
      if ($scope.formErrors !== null) {
        return;
      }
      $scope.saving = true;
      $http.get(Config.get().apiUrl + '/users/' + id, params).then(function updateUser(data) {
        var user = data.data;
        user.password = $scope.passwordResetData.password;
        $http.put(Config.get().apiUrl + '/users/' + id, user, params).then(function updateUserSuccess() {
          $scope.tryLogin($scope.passwordResetData.email, $scope.passwordResetData.password);
        }, function updateUserFailure(response) {
          Logger.error("Error updating password, response status " + response.status);
          $scope.saveError = "There was an error updating your password: " + response.data.message;
          $scope.saving = false;
        });
      });
    };
  }]);
})();
